module.exports = __webpack_public_path__ + "img/cost.4f6fd66c.png";